import { createContext, useContext } from 'react';

export interface RuntimeConfig {
  apiBaseUrl: string;
  msalClientId: string;
  msalAuthority: string;
  msalRedirectUri: string;
  portalEnv: string;
}

export const RuntimeConfigContext = createContext<RuntimeConfig>({
  apiBaseUrl: '',
  msalClientId: '',
  msalAuthority: 'https://login.microsoftonline.com/common',
  msalRedirectUri: window.location.origin,
  portalEnv: 'local',
});

export const useRuntimeConfig = () => useContext(RuntimeConfigContext);
